module.exports = __webpack_public_path__ + "static/media/subICloud5.a580b5e6.png";